import axios from 'axios';
import { SiteConstructor, SiteSupervisor } from 'app/edozvola/cases/construction-participants/model/construction-participants.model';

export const saveSiteConstructor = async (idCase: string, siteConstructor: SiteConstructor): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/construction-participants/site-constructor/${idCase}`, siteConstructor)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchSiteConstructors = async (
  idCase: string,
  page: number,
  size: number,
  column: string,
  direction: string,
): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(
          `api/construction-participants/site-constructor/find-all/${idCase}?page=${page}&size=${size}&column=${column}&direction=${direction}`,
        )
        .then(response => resolve(response.data));
    });
  }
};

export const fetchSiteConstructor = async (idSiteConstructor: string): Promise<SiteConstructor> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-participants/site-constructor/${idSiteConstructor}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteSiteConstructor = async (idSiteConstructor: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/construction-participants/site-constructor/${idSiteConstructor}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copySiteConstructors = async (caseUuid: string, caseUuidToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-participants/site-constructor/copy/${caseUuid}/${caseUuidToCopyFrom}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchSiteSupervisor = async (idCase: string, idSiteSupervisor: string): Promise<SiteSupervisor> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-participants/site-supervisor/${idCase}/${idSiteSupervisor}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchSiteSupervisors = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(
          `api/construction-participants/site-supervisor/find-all/${idCase}?page=${page}&size=${size}&column=${column}&direction=${direction}`,
        )
        .then(response => resolve(response.data));
    });
  }
};

export const saveSiteSupervisor = async (idCase: string, siteSupervisor: SiteSupervisor): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/construction-participants/site-supervisor/${idCase}`, siteSupervisor)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteSiteSupervisor = async (idCase: string, idSiteSupervisor: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/construction-participants/site-supervisor/${idCase}/${idSiteSupervisor}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copySiteSupervisors = async (caseUuid: string, caseUuidToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-participants/site-supervisor/copy/${caseUuid}/${caseUuidToCopyFrom}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
